import type { ParentTaskType } from "@repo/api";

export const isPhoneCallScheduledTask = (
  parentTaskType?: ParentTaskType,
  subTaskType?: string
) => {
  return parentTaskType === "task" && subTaskType === "phoneCallScheduled";
};
